import { render, staticRenderFns } from "./TableItemPreview.vue?vue&type=template&id=6593b8df&scoped=true&"
import script from "./TableItemPreview.vue?vue&type=script&lang=js&"
export * from "./TableItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./TableItemPreview.vue?vue&type=style&index=0&id=6593b8df&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6593b8df",
  null
  
)

export default component.exports